






























































import { Vue, Component, Prop } from "vue-property-decorator";
import { ContattoAziendaInfo } from "../../_models/contattoAzienda";

@Component
export default class DetailsContattoAzienda extends Vue {
  @Prop() info!: ContattoAziendaInfo;
}
